import {TorresstreamApi} from "../apis/torrestream-api/torresstream-api";

export const legalServers = {

    "AIOStream": {
        getEmbedUrl: (type, tmdbId, season, episode, item) => {
        },
        sandbox: false,
        player: 'AIOStreamViewer',
        type: 'both',
    },
    "TowersStream": {
        getEmbedUrl: (type, tmdbId, season, episode, item) => {
            if (type === "movie") {
                return TorresstreamApi.baseUrl + `streamContent?torrentId=${tmdbId}`;
            }

            return TorresstreamApi.baseUrl + `streamContent?torrentId=${tmdbId}`;
        },
        sandbox: false,
        player: 'towersStreamViewer',
        type: 'both',
    },
    "VerOnline": {
        getEmbedUrl: (type, tmdbId, season, episode, item) => {
            throw new Error("Embedding not supported");
        },
        disabled: false,
        sandbox: false,
        flag: "fi fi-es",
        player: 'veronlineStreamPlayer',
        type: 'tv',
    },
    "player4u": {
        getEmbedUrl: (type, tmdbId, season, episode, item) => {
            return item.original_title ?? item.original_name;
        },
        sandbox: false,
        flag: "fi fi-gb",
        player: 'player4u',
        type: 'both',
    },
    "videasy": {
        getEmbedUrl: (type, tmdbId, season, episode, item) => {
            if (type === "movie") {
                return `https://player.videasy.net/movie/${tmdbId}?nextEpisode=true&autoplayNextEpisode=true&episodeSelector=true&color=8B5CF6`;
            }

            return `https://player.videasy.net/tv/${tmdbId}/${season}/${episode}?nextEpisode=false&autoplayNextEpisode=false&episodeSelector=false&color=8B5CF6`;
        },
        sandbox: false,
        flag: "fi fi-gb",
        player: 'iframe',
        type: 'both',
    },
    "moviesapi": {
        getEmbedUrl: (type, tmdbId, season, episode, item) => {
            if (type === "movie") {
                return `https://cdn.moviesapi.club/embed/movie/${tmdbId}`;
            }

            return `https://cdn.moviesapi.club/embed/tv/${tmdbId}/${season}/${episode}`;
        },
        sandbox: false,
        flag: "fi fi-gb",
        player: 'iframe',
        type: 'both',
    }
}

export const correctType = (server, type) => {
    return legalServers[server]?.type === type || legalServers[server]?.type === 'both' || server === 'SquadFlix';
}

export const getServers = () => {
    return Object.keys(legalServers).map(server => {
        return {
            value: server,
            flag: legalServers[server].flag,
            disabled: legalServers[server].disabled === true,
        }
    });
}

export const canUsePlayer = (server, player) => {
    return legalServers[server]?.player === player;
}

export const getEmbedUrl = (server, type, tmdbId, season, episode, item) => {
    return legalServers[server].getEmbedUrl(type, tmdbId, season, episode, item);
}

export const worksInSandBox = (server) => {
    return legalServers[server].sandbox;
}
